import { ColorMode } from '@airgap/beacon-types';
let colorMode = ColorMode.LIGHT;
export const setColorMode = (mode) => {
    colorMode = mode;
};
export const getColorMode = () => colorMode;
//# sourceMappingURL=colorMode.js.map